import { C } from "../theme/colors";

export default function Divider() {
  return <div style={{width:48,height:3,background:C.gold,borderRadius:2,margin:"16px 0 28px"}} />;
}
